<template>
  <div>
    <b-modal size="lg" v-model="is_show" :title="modalTitle" hide-footer @hide="onHide">
      <b-form @submit.prevent="onSubmit" @reset="onHide" v-loading="loading.detail">
        <b-form-group label="Name">
          <b-input
            v-model="form.name"
            placeholder="Input content name"
            type="text"/>
        </b-form-group>
        <b-form-group label="Description">
          <b-input
            v-model="form.description"
            placeholder="Input content Description"
            type="text"/>
        </b-form-group>
        <!-- <b-form-group label="Slug">
          <b-input
            v-model="form.slug"
            placeholder="Input content slug"
            type="text"/>
        </b-form-group> -->
        <b-form-group label="Status">
          <el-select v-model="form.status" class="w-full" size="medium" placeholder="Select status">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </b-form-group>
        <div class="d-flex flex-row float-right">
          <el-button @click="onSubmit" :loading="loading.submit" class="mr-2 ml-2" size="small" type="primary">Submit</el-button>
          <el-button @click="onHide" size="small" class="mr-2">Cancel</el-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import {
  ADD_CATEGORY_CONTENT, UPDATE_CATEGORY_CONTENT, DETAIL_CATEGORY_CONTENT
} from '@/store/modules/app_content';
import popupErrorMessages from '@/library/popup-error-messages';
import emptyStateImage from '@/assets/images/empty-state.png';
export default {
  name: 'ModalSectionCategoriesContent',
  components: {
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'add',
    },
    selectedContent: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      list: [],
      total_rows: 0,
      emptyStateImage,
      is_show: false,
      loading: {
        submit: false,
        detail: false,
      },
      form: {
          name: "",
          description: "",
          items: [],
          status: false,
      },
      content_id: null,
      statusOptions: [
          {
            value: true,
            label: 'Active',
          }, 
          {
            value: false,
            label: 'Inactive',
          },
        ],
      search_keyword: 'full_name',
      search: '',
      per_page: 10,
      page: 1,
      list_app: [],
      private_options: [
         {
          value: true,
          label: 'True',
        },
        {
          value: false,
          label: 'False',
        },
      ]
    };
  },
  computed: {
    modalTitle() {
      return this.type === 'add' ? 'Add category Content' : 'Update category Content';
    },
    showingFromApp() {
      return this.total_rows ? ((this.page - 1) * this.per_page) + 1 : 0;
    },
    showingUntilApp() {
      if (this.total_rows) {
        if (this.list_app.length < this.per_page) {
          return this.total_rows;
        }
        return this.page * this.per_page;
      }
      return 0;
    },
  },

  methods: {
    async onSubmit() {
      this.loading.submit = true;
      if (this.type === 'edit') {
        await this.updateContent();
      } else {
        await this.$store.dispatch(ADD_CATEGORY_CONTENT, this.form)
          .then(() => {
            this.$message({
              title: 'Success',
              type: 'success',
              message: 'Content successfully created',
            });
            this.$emit('afterSubmit');
          }).catch((err) => {
            popupErrorMessages(err.response.data);
          });
      }
      this.loading.submit = false;
    },
    async updateContent() {
      await this.$store.dispatch(UPDATE_CATEGORY_CONTENT, {
        _id: this.content_id,
        data: this.form,
      }).then(() => {
        this.$message({
          title: 'Success',
          type: 'success',
          message: 'Content successfully updated',
        });
        this.$emit('afterSubmit');
      }).catch((err) => {
        popupErrorMessages(err.response.data);
      });
    },
    searchHandlerBanner() {
      this.page = 1;
      this.search = this.search;
      this.getList();
    },
    onHide() {
      this.form = {
        description: '',
        name: '',
        status: false,
        items: [],
      };
      this.$emit('onHide');
    },
    async getDetail(_id) {
      this.loading.detail = true;
      await this.$store.dispatch(DETAIL_CATEGORY_CONTENT, { _id })
      .then((res) => {
        const content = res?.rows;
        this.content_id = content?._id;
        this.form = {
          name: content?.name,
          index: content.index,
          description: content.description,
          items: content.items,
          status: content.status,
          slug: content.slug,
        };
      })
      .catch((err) => {
      });
        this.loading.detail = false;
    },
  },
  watch: {
    show() {
      this.is_show = this.show;
      if (this.show) {
        if (this.type === 'edit') {
          this.getDetail(this.selectedContent._id);
        }
      }
    },
  },
};
</script>